import * as React from 'react';
import classnames from 'classnames';
import { DateTime } from '@grandvisionhq/common';
import { Label } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const PrescriptionInfoBar = ({ storeName , expiryDate , className  })=>{
    const { getLabel , locale  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('prescription-infobar', className)
    }, storeName && /*#__PURE__*/ React.createElement("div", {
        className: "prescription-infobar__store-name",
        "data-t": "store-name"
    }, storeName), /*#__PURE__*/ React.createElement(Label, {
        type: "neutral",
        className: "prescription-infobar__label"
    }, /*#__PURE__*/ React.createElement("span", null, getLabel('account.prescription.expiryDate'), ": "), /*#__PURE__*/ React.createElement(DateTime, {
        dateTime: expiryDate,
        locale: locale
    })));
};
var PrescriptionInfoBar$1 = PrescriptionInfoBar;

export { PrescriptionInfoBar$1 as default };
//# sourceMappingURL=PrescriptionInfoBar.js.map
